// HOPPhomes ChatGPT Ads landing configuration
// Route: /ajanlat
// Campaign: hopphomes_ajanlat / source: chatgpt

export const landingConfig = {
  campaign: 'hopphomes_ajanlat',
  source: 'chatgpt',

  brand: {
    name: 'HOPPhomes',
    logoUrl: '/logo_ai.png',
    logoAlt: 'HOPPhomes logó',
    primaryColor: '#e31937',
    primaryColorHover: '#cc1530',
    darkBg: '#0a0a0a',
    cardBg: '#161616',
  },

  hero: {
    eyebrow: 'A HOPPx ökoszisztéma része',
    headlineTop: 'SAJÁT OTTHONT TERVEZEL?',
    headlineLines: [
      { text: 'SZERKEZETKÉSZ HÁZAK — 289.000 FT/M²-TŐL', style: 'accent' },
      { text: 'KULCSRAKÉSZ HÁZAK — 500.000 FT/M²-TŐL', style: 'accent' },
    ],
    subheadline:
      'Mondd el néhány kattintással, milyen otthont szeretnél, és segítünk megtalálni a számodra megfelelő megoldást.',
    ctaLabel: 'MEGNÉZEM A LEHETŐSÉGEIMET →',
    trustBadges: [
      { icon: '⚡', label: 'GYORS' },
      { icon: '✓', label: 'EGYSZERŰ' },
      { icon: '🛡️', label: 'KÖTELEZETTSÉGMENTES' },
    ],
    hoppySpeech: 'Szia! 👋 Segítek megtalálni a számodra megfelelő HOPPhomes megoldást.',
  },

  steps: [
    {
      id: 'home_type',
      type: 'choice',
      hoppySpeech: 'Szia! 👋 Segítek megtalálni a számodra megfelelő HOPPhomes megoldást.',
      question: 'MILYEN OTTHONT KERESEL?',
      options: [
        { value: 'kulcsrakész', label: 'Kulcsrakész ház' },
        { value: 'szerkezetkész', label: 'Szerkezetkész ház' },
        { value: 'kapszulaház', label: 'Kapszulaház / kis ház' },
        { value: 'nem_tudom', label: 'Még nem tudom — segítsenek választani' },
      ],
      gaEventName: 'home_type_selected',
      gaParamKey: 'home_type',
    },
    {
      id: 'size',
      type: 'choice',
      question: 'MEKKORA HÁZBAN GONDOLKODSZ?',
      options: [
        { value: '30-50', label: '30–50 m²' },
        { value: '51-80', label: '51–80 m²' },
        { value: '81-120', label: '81–120 m²' },
        { value: '120+', label: '120 m² felett' },
        { value: 'nem_tudom', label: 'Még nem tudom' },
      ],
      gaEventName: 'size_selected',
      gaParamKey: 'size',
    },
    {
      id: 'land_status',
      type: 'choice',
      question: 'VAN MÁR TELKED?',
      options: [
        { value: 'van', label: 'Igen, már megvan a telek' },
        { value: 'keresem', label: 'Még keresem a telket' },
        { value: 'nincs', label: 'Nincs — ebben is segítséget kérek' },
      ],
      gaEventName: 'land_status_selected',
      gaParamKey: 'land_status',
    },
    {
      id: 'timeline',
      type: 'choice',
      question: 'MIKOR SZERETNÉL BELEVÁGNI?',
      options: [
        { value: 'azonnal', label: 'Minél hamarabb' },
        { value: '1-3_hónap', label: '1–3 hónapon belül' },
        { value: '3-6_hónap', label: '3–6 hónapon belül' },
        { value: '6-12_hónap', label: '6–12 hónapon belül' },
        { value: 'tájékozódás', label: 'Egyelőre csak tájékozódom' },
      ],
      gaEventName: 'timeline_selected',
      gaParamKey: 'timeline',
    },
    {
      id: 'budget',
      type: 'choice',
      question: 'MILYEN KÖLTSÉGVETÉSBEN GONDOLKODSZ?',
      options: [
        { value: '15M_alatt', label: '15 millió Ft alatt' },
        { value: '15-30M', label: '15–30 millió Ft' },
        { value: '30-50M', label: '30–50 millió Ft' },
        { value: '50M_felett', label: '50 millió Ft felett' },
        { value: 'nem_tudom', label: 'Még nem tudom' },
      ],
      gaEventName: 'budget_selected',
      gaParamKey: 'budget',
    },
  ],

  contactStep: {
    headline: 'MÁR MAJDNEM KÉSZ!',
    subheadline:
      'Add meg az elérhetőségedet, és felvesszük veled a kapcsolatot, hogy átbeszéljük, milyen HOPPhomes megoldás illik az elképzeléseidhez.',
    fields: [
      { name: 'name', label: 'Név', type: 'text', required: true, placeholder: 'Teljes név' },
      { name: 'phone', label: 'Telefonszám', type: 'tel', required: true, placeholder: '06301234567', validation: 'hu-phone' },
      { name: 'email', label: 'E-mail (opcionális)', type: 'email', required: false, placeholder: 'nev@example.com', validation: 'email' },
    ],
    consentText: 'Elfogadom, hogy a HOPPhomes a megadott adataimat az',
    consentLinkHref: '/jogi-nyilatkozat',
    consentLinkLabel: 'adatkezelési tájékoztatóban',
    consentTextAfter: 'foglaltak szerint kezelje.',
    ctaLabel: 'KÉREM A VISSZAHÍVÁST',
    footnote: 'Díjmentes • Kötelezettségmentes • Gyors kapcsolatfelvétel',
  },

  thankYou: {
    headline: 'KÖSZÖNJÜK! ✓ Megkaptuk az igényedet.',
    subtext:
      'Hamarosan felvesszük veled a kapcsolatot, hogy átbeszéljük az otthonoddal kapcsolatos elképzeléseidet.',
    ctaLabel: 'MEGNÉZEM A HOPPHOMES-T →',
    ctaHref: '/',
  },

  seo: {
    title: 'Saját otthont tervezel? | HOPPhomes',
    description:
      'Szerkezetkész házak 289.000 Ft/m²-től, kulcsrakész házak 500.000 Ft/m²-től. Töltsd ki 1 perc alatt az igényfelmérőt, és segítünk megtalálni a megfelelő HOPPhomes megoldást.',
  },
};
